import {useEffect} from 'react'
import {useNavigate} from 'react-router'
import {preloadResources} from 'preload'
import {Logotype} from 'brand/Logotype'

export const Splash = () => {
  preloadResources.splash()
  const nav = useNavigate()

  useEffect(() => {
    if (window.location.pathname === '/') {
      setTimeout(() => nav('/app-setup'), 3000)
    }
  })

  return (
    <div className="fullscreen-bg splash">
      <div className="shade">
        <section className="splash">
          <div className="content align-end">
            <Logotype align="end" />
          </div>
        </section>
      </div>
    </div>
  )
}
